<template>
    <div>
        <v-btn @click="submit()" class="lime mt-2 ml-2 mr-2">Submit</v-btn>
        <span class="icon-container"> 
            <span v-if="isSaving">
                <v-icon class="spin">sync</v-icon>
            </span>

            <span v-if="saveSuccess">
                <v-icon color="green">done</v-icon>
                <span>Changes saved successfully</span>
            </span>
        </span>
    </div>
</template>

<script>
/**
* A Vue containing the batch loader submit button and responsible for handling the submission of the form and handling the response
*
*/

export default {
    name: 'hotel-batch-loader-submit-form',
    props: ['payload'],
    data () {
        return {
            isSaving: false,
            saveSuccess: false,
        }
    },

    methods: {
        submit(){
            this.initSavingState();
  
            let payload = this.payload;
            
            for (let [roomKey, rates] of Object.entries(payload.standardRates)){
                for (let [rateKey, rate] of Object.entries(rates)){
                    if (rate.rate_status){
                        rate.is_open = rate.rate_status != 'closed' ? 1 : 0;
                        rate.is_indicative = rate.rate_status == 'indicative' ? 1 : 0;
                    }
                }
            }

            if (!this.checkSubmitPayloadIsValid()){
                return;
            }
            
            axios.post('/api/hotel-batch-loader', payload)
                .then((response) => {
                    this.handleSubmitResponse(response);
                })
                .catch((error) => {
                    this.handleSubmitError(error);
                })
                .finally(() => {
                    this.isSaving = false;
                });
        },
        

        handleSubmitResponse(response){            
            if (response.data.success){
                this.showSuccessMessage();
                this.$emit('save-success');
            } else {
                this.showErrorMessage(response.data.error);
            }
        },

        handleSubmitError(error){
            this.showErrorMessage(error.response.data.message);
            this.saveSuccess = false;
        },

        initSavingState(){
            this.isSaving = true;
            this.saveSuccess = false;
            this.$emit('update-error-message', '');
        },

        showSuccessMessage(){
            this.saveSuccess = true;
            
            setTimeout(() => {
                this.saveSuccess = false;
            }, 5000);
        },

        showErrorMessage(errorMessage){
            this.$emit('update-error-message', errorMessage);
        },

        checkSubmitPayloadIsValid(){
            let updatingAllWeekdays = this.payload.days.length == 7;
            if (updatingAllWeekdays){
                for (let [roomKey, rates] of Object.entries(this.payload.restrictions)){
                    for (let [rateKey, rate] of Object.entries(rates)){
                        if ('days_checkin' in rate && rate.days_checkin == 1){
                            this.showErrorMessage('Cannot set no check-in for all weekdays');
                            this.saveSuccess = false;
                            this.isSaving = false;
                            return false;
                        }

                        if ('days_checkout' in rate && rate.days_checkout == 1){
                            this.showErrorMessage('Cannot set no check-out for all weekdays');
                            this.saveSuccess = false;
                            this.isSaving = false;
                            return false;
                        }
                    }
                }
            }
            return true;
        }
    },

    mounted() {
    },

    computed: {

    },

    watch: 
        {
    }
}
</script>

<style>
    
</style>
